
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2A9.998 9.998 0 002 12a9.998 9.998 0 0010 10c5.522 0 10-4.477 10-10S17.521 2 12 2zm3.915 12.98H12.85v1.789c0 .426-.34.765-.852.765-.426 0-.85-.339-.85-.765v-1.79H8.083c-.427 0-.767-.424-.767-.849 0-.426.342-.853.767-.853h3.065V12H8.083c-.427 0-.767-.338-.767-.85 0-.426.341-.853.767-.853h2.724L8.339 7.913a.823.823 0 010-1.191.825.825 0 011.192 0l2.554 2.47 2.383-2.386a.827.827 0 011.192 0c.34.34.34.853 0 1.191l-2.47 2.386h2.725c.426 0 .767.426.767.851 0 .427-.34.853-.767.853L12.85 12v1.28h3.064c.426 0 .767.34.767.852 0 .424-.34.848-.767.848v.002z"}})])
          )
        }
      }
    